export default "__VITE_ASSET__BuLhLgWI__"